import { jsx } from "react/jsx-runtime";
import "react";
import { PropertyTaxCalculator } from "@zillow/zrs-traffic";
const PROPERTY_TAX_CALCULATOR_CONFIGS = {
  prod: {
    zgGraphUrl: "https://www.zillow.com/zg-graph",
    callerId: "zrs-traffic",
    mortgageUrl: "https://mortgageapi.zillow.com/getAnnualPropertyTaxRate",
    mortgagePartnerId: "RD-WXDQSGN"
  },
  default: {
    zgGraphUrl: "https://www.qa.zillow.net/graphql",
    callerId: "zrs-traffic",
    mortgageUrl: "https://mortgageapi.qa.zillow.net/getAnnualPropertyTaxRate",
    mortgagePartnerId: "RD-GKZRBBL"
  }
};
const BlockPropertyTaxCalculator = () => {
  const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  const props = PROPERTY_TAX_CALCULATOR_CONFIGS[NEXT_PUBLIC_ENV] || PROPERTY_TAX_CALCULATOR_CONFIGS.default;
  return /* @__PURE__ */ jsx(PropertyTaxCalculator, { ...props });
};
export {
  BlockPropertyTaxCalculator as default
};
